export default {
  missingOppositeContent: {
    '&:before': {
      display: 'none'
    }
  }
};
